import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"

const Galerij = ({data, taal})=>{
return <div className="galerij">
	{data.allMetadataYaml.edges.map(edge=>
		<div className="galerij-afb" key={edge.node.id}>
		<Link to={'/' + taal + '/' + edge.node.id}><img width="100px" height="auto" src={'/img/' + edge.node.file} alt=""/></Link>
		</div>)}
	</div>
}

export default Galerij
